<div class="create-item-content">
  <input #nameInput class="input" [placeholder]="placeholder" [(ngModel)]="name" (ngModelChange)="validate($event)" (keydown.enter)="save()" (keydown.esc)="close()">
  <div class="button" (click)="save()" [class.disabled]="!emptyName && !name?.length || error">Save</div>
</div>

<!-- Error -->
<div class="error" *ngIf="error">{{ error.message }}</div>
